module.exports = __webpack_public_path__ + "static/media/Cash-for-Damaged-Cars.bedb4dc1.jpg";